import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { Product, ProductVariant, SelectedOption } from "@shopify/hydrogen-react/storefront-api-types"

import { ProductStockVariantsDropdown } from "@app/components/Product/Stock/ProductStockVariantsDropdown"

type Props = {
  activeOptions: Array<SelectedOption>
  activeVariant: ProductVariant | null
  disableNoActiveOption: (state: boolean) => void
  handleOption: (option: SelectedOption) => void
  noActiveOption: boolean
  product?: Product
}

export const ProductStockVariantsDropdowns: React.FC<Props> = React.memo(
  ({ activeOptions, activeVariant, disableNoActiveOption, handleOption, noActiveOption, product }) =>
    product?.variants?.length > 1 ? (
      <Box pos="relative" zIndex={600}>
        <Text variant="text14" mb={2}>
          Selection
        </Text>
        {product?.options?.map((option, index) => (
          <ProductStockVariantsDropdown
            key={index}
            option={option}
            activeOptions={activeOptions}
            activeVariant={activeVariant}
            handleOption={handleOption}
            noActiveOption={noActiveOption}
            disableNoActiveOption={disableNoActiveOption}
          />
        ))}
      </Box>
    ) : null
)
